// extracted by mini-css-extract-plugin
export default {"artworks__list":"ArtWorksList_artworks__list__PuRPO"};